import {
  parsePhoneNumber,
  isPossiblePhoneNumber,
  CountryCode,
} from "libphonenumber-js";

type PhoneNumberOptions = {
  defaultCountry?: CountryCode;
};

export function phoneNumber(
  number: string,
  options: PhoneNumberOptions = {},
): string {
  const { defaultCountry = "US" } = options;

  if (isPossiblePhoneNumber(number, defaultCountry)) {
    return parsePhoneNumber(number, defaultCountry).formatNational();
  } else {
    return number;
  }
}
